export default __webpack_public_path__ + "static/media/img-guide-gt-popup-2-be_dt.21718669.png";